export default "__VITE_ASSET__ab5b3306__"